%YAML 1.1
%TAG !u! tag:unity3d.com,2011:
--- !u!114 &11400000
MonoBehaviour:
  m_ObjectHideFlags: 0
  m_CorrespondingSourceObject: {fileID: 0}
  m_PrefabInstance: {fileID: 0}
  m_PrefabAsset: {fileID: 0}
  m_GameObject: {fileID: 0}
  m_Enabled: 1
  m_EditorHideFlags: 0
  m_Script: {fileID: 11500000, guid: 17c14f584f7d29740952e55a51d6a1fe, type: 3}
  m_Name: BossBear
  m_EditorClassIdentifier: 
  unitModel: {fileID: 3241138547371686306, guid: cced8a6bc51f31f43bca07dfe748e4e7,
    type: 3}
  heroClass: 24
  isHealer: 0
  isInternal: 1
  isBoss: 1
  level: 0
  attackSpeed: 1
  baseHP: 6000
  baseGCDMultiplier: 100
  unitName: Yorgun the Frostforged
  unitSpec: Polar
  icon: {fileID: 2800000, guid: 20bebf031d70e6e4eaa69513f49b7bf3, type: 3}
  backgroundColor: {r: 0.8588235, g: 0.8588235, b: 0.854902, a: 1}
  textColor: {r: 0.4, g: 0.4, b: 0.4, a: 1}
  typeIcon: {fileID: 21300000, guid: 423717ccb76a74e489e5d288c5af5780, type: 3}
  type: HEALER
  description: 
  hitboxScale: {x: 4, y: 4, z: 4}
  selectionCircleScale: {x: 6, y: 2, z: 6}
  mouseHitboxScale: {x: 4, y: 3, z: 4}
  hitAnimationType: 3
  dieAnimationType: 1
  animationSpeedMultiplier: 0.7
  supportsStopWalkAnimation: 1
  isLeftHandClosed: 0
  isRightHandClosed: 1
  dualWields: 0
  runAnimation: {fileID: 7400000, guid: 5e04ec40bbc3ac84796a85672bfea74b, type: 3}
  sprintAnimation: {fileID: 7400000, guid: 5e04ec40bbc3ac84796a85672bfea74b, type: 3}
  idleAnimation: {fileID: 7400000, guid: 738b43c856812d44485cce817b79ea06, type: 3}
  stopWalkAnimation: {fileID: 0}
  footstepSounds:
  - {fileID: 8300000, guid: f6a0604181d205c48a1487b0a420b0e0, type: 3}
  - {fileID: 8300000, guid: 129dbdeb1611723489ad2445e4d62806, type: 3}
  - {fileID: 8300000, guid: 761b3b0bb7a210f45ab22851c8823fd5, type: 3}
  - {fileID: 8300000, guid: 0207beb000d2a984aba8d8c18033978d, type: 3}
  - {fileID: 8300000, guid: 3331792b169924448bd774007767d02b, type: 3}
  - {fileID: 8300000, guid: a01ca2c05517c2440923677ccbcf13c4, type: 3}
  - {fileID: 8300000, guid: a1932d9612ddc6c4b89c2f012dd59eb2, type: 3}
  - {fileID: 8300000, guid: e307c1e688ce6fa4090baf3702ff14e3, type: 3}
  - {fileID: 8300000, guid: 0b508f958dc2fc14dae01bc74f6c3896, type: 3}
  - {fileID: 8300000, guid: c75f01921060aea468faa65f382dfdf4, type: 3}
  - {fileID: 8300000, guid: c7dfd018c818f2e479b45a715e1a2a6c, type: 3}
  - {fileID: 8300000, guid: 330aba8c48b34b64baa9d90ca470ea6c, type: 3}
  - {fileID: 8300000, guid: c891b25e37059b44eb224f93803a764a, type: 3}
  - {fileID: 8300000, guid: f438ee57a0c246b41ba90434f9e37112, type: 3}
  - {fileID: 8300000, guid: 3a735f9d10cd39f4292bec35fb227445, type: 3}
  - {fileID: 8300000, guid: 232d552e7c3364c41afe7c570ce7b088, type: 3}
  - {fileID: 8300000, guid: 586061caa5f6f294886fc39578ccd458, type: 3}
  - {fileID: 8300000, guid: ed9abe2423737ba42940d0efff5508c9, type: 3}
  - {fileID: 8300000, guid: 0107856a8ad9a31498651137a892e49d, type: 3}
  - {fileID: 8300000, guid: 5ec4507ee2b342e48a3de0355249e568, type: 3}
  passiveIcon: {fileID: 21300000, guid: d3857588363cc674ea1157723c39247f, type: 3}
  passiveName: 
  passiveDescription: 
